import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import {userService} from "../../../services/UserService";
import actionTypes from "../../../store/actionTypes";
import {Button, Typography, Paper} from "@material-ui/core";
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {Help} from '@material-ui/icons';

const texts = require('../../../texts/riegoneto.json')


interface IProps {
    setMetodo(metodo: string): void
    setSector(sector: string): void
    openNota(callback: string): void
    riego: Record<string, Record<string, number>>
    metodo: string
    sector: string
    idioma: string
    level: number
}

interface IState {
    text: Record<string, string>
}

class GraficoRiego extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma]
    };

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        this.props.setSector('')
        // console.log(this.props.riego)
    }

    handleClick = (data: any, index: number) => {
        this.props.setSector(data.name)
    };

    render () {
        const data = []
        for (let key of Object.keys(this.props.riego[this.props.metodo])) {
            data.push({
                name: key,
                riego : this.props.riego[this.props.metodo][key]
            })
        }

        // let rpas_hibrida = false
        // for (let sector of Object.keys(this.props.riego["rpas_hibrida"])){
        //     if (this.props.riego["rpas_hibrida"][sector] !== 0) rpas_hibrida = true
        // }

        let max = 0
        for (let metodo of Object.keys(this.props.riego).filter(el => el !== 'area')) {
            for (let key of Object.keys(this.props.riego[metodo])) {
                if (this.props.riego[metodo][key] > max) {
                    max = this.props.riego[metodo][key]
                }
            }
        }

        let domino = [0, Math.round(max*1.1)]
        if (max <= 0.1) domino = [0, 1]
        if (0.1 < max && max <= 1) domino = [0, Math.round(max*110)/100]
        if (1 < max && max <= 10) domino = [0, Math.round(max*11)/10]

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: 30,
                        height: 50,
                        width: '100%',
                        marginLeft: 40,
                        fontFamily: "Poppins"
                    }}
                >
                    {this.state.text["1"]}
                </Typography>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        height: '100%',
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 20
                    }}
                >
                    <Paper
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            height: '100%',
                            marginRight: 20,
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 20
                        }}
                    >

                        <ResponsiveContainer
                            width="100%"
                            height="100%"
                        >
                            <BarChart
                                data={data}
                                margin={{
                                    top: 30,
                                    right: 30,
                                    left: 30,
                                    bottom: 30,
                                }}
                            >
                                <CartesianGrid />
                                <Bar
                                    dataKey="riego"
                                    onClick={this.handleClick}
                                    radius={50}
                                    barSize={data.length <= 4? 60 : 30}
                                >
                                    {data.map((entry: any, index: number) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            cursor="pointer"
                                            fill={entry.name === this.props.sector ? '#80ED99' : 'rgb(40,140,198)'}
                                        />
                                    ))}
                                </Bar>
                                <YAxis
                                    label={{ value: 'm³', angle: -90, position: 'Left', fontSize: 30, dx:-20, fontFamily: "Poppins"}}
                                    domain={domino}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </Paper>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: 150,
                            height: '100%',
                            justifyContent: "space-between"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 150,
                                height: '25%',
                            }}
                        >
                            <Button
                                variant={"contained"}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: this.props.metodo === 'fao'? "#aaa" : "white",
                                    borderRadius: 20
                                }}
                                onClick={() => this.props.setMetodo('fao')}
                            >
                                <Typography
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 20,
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["5"]}
                                </Typography>
                            </Button>

                            <Help
                                style={{
                                    zIndex: 100,
                                    width: 25,
                                    height: 25,
                                    marginTop: -5,
                                    marginRight: -25,
                                    marginLeft: -15
                                }}
                                onClick={() => this.props.openNota(this.state.text["2"])}
                            />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 150,
                                height: '25%',
                            }}
                        >
                            <Button
                                variant={"contained"}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: this.props.metodo === 'satelital'? "#aaa" : "white",
                                    borderRadius: 20
                                }}
                                onClick={() => this.props.setMetodo('satelital')}
                                disabled={this.props.level === 1 && userService.getUser() !== "demo"}
                            >
                                <Typography
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 20,
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["6"]}
                                </Typography>
                            </Button>

                            <Help
                                style={{
                                    zIndex: 100,
                                    width: 25,
                                    height: 25,
                                    marginTop: -5,
                                    marginRight: -25,
                                    marginLeft: -15
                                }}
                                onClick={() => this.props.openNota(this.state.text["3"])}
                            />

                        </div>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: 150,
                                height: '25%',
                            }}
                        >
                            <Button
                                variant={"contained"}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: this.props.metodo === 'rpas_hibrida'? "#aaa" : "white",
                                    borderRadius: 20
                                }}
                                onClick={() => this.props.setMetodo('rpas_hibrida')}
                                disabled={[1, 2, 4].includes(this.props.level) && userService.getUser() !== "demo"}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <Typography
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: 20,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["7"]}
                                    </Typography>
                                    <Typography
                                        style={{
                                            fontWeight: "bold",
                                            fontSize: 20
                                        }}
                                    >
                                        {this.state.text["8"]}
                                    </Typography>
                                </div>

                            </Button>

                            <Help
                                style={{
                                    zIndex: 100,
                                    width: 25,
                                    height: 25,
                                    marginTop: -5,
                                    marginRight: -25,
                                    marginLeft: -15
                                }}
                                onClick={() => this.props.openNota(this.state.text["4"])}
                            />

                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


const mapStateToProps = (state: IStore) => ({
    riego: state.riego.riego,
    metodo: state.riego.metodo,
    sector: state.riego.sector,
    idioma: state.config.idioma,
    level: state.navegacion.level
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setMetodo: (metodo: string) => dispatch({type: "set-riego-metodo", metodo}),
    setSector: (sector: string) => dispatch({type: "set-riego-sector", sector}),
    openNota: (callback: string) => dispatch({type: "open-nota-dialog", callback})
});

export default connect(mapStateToProps, mapDispatchToProps)(GraficoRiego);
